"use client";
import { createContext, useContext, useState } from "react";

export const CampaignContext = createContext({
    campaignFilters: {
        district: undefined,
        service: undefined,
    },
    clearFilters: () => {},
    setCampaignFilters: (ev: any) => {},
});

export const CampaignProvider = ({ children }: any) => {
    const [campaignFilters, setCampaignFilters] = useState({} as any);

    const clearFilters = () => {
        setCampaignFilters({
            district: undefined,
            service: undefined,
        });
    };

    const value = {
        campaignFilters,
        setCampaignFilters,
        clearFilters,
    };

    return (
        <CampaignContext.Provider value={value}>{children}</CampaignContext.Provider>
    );
};

export const useCampaignContext = () => {
    return useContext(CampaignContext);
};